import React, { Component, Fragment } from 'react'
import Slide from '../../Slide'
import Carousel from 'antd/lib/carousel'
import VideoSliderControls from '../../VideoSliderControls'
import { resolutions } from '../../../utils/constants'
import Dots from '../Dots'
import './index.sass'

class Slider extends Component {
  state = {
    width: window.innerWidth,
    activeComponent: 0,
  }

  updateDimensions = () => {
    this.setState({ width: window.innerWidth })
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions)
  }

  componentDidMount = () => {
    window.addEventListener('resize', this.updateDimensions)
  }

  onHandleNextSlide = () => {
    this.slider.slick.slickNext()
  }

  onHandlePrevSlide = () => {
    this.slider.slick.slickPrev()
  }

  chooseSelectedSlide = index => {
    this.slider.slick.slickGoTo(index)
  }

  afterChange = index => {
    this.setState({ activeComponent: index })
  }

  render = () => {
    const { slider } = this.props
    const { width, activeComponent } = this.state
    return (
      <Fragment>
        <Carousel
          infinite={true}
          speed={500}
          slidesToScroll={1}
          slidesToShow={width < resolutions.tablet ? 1 : 3}
          ref={ref => (this.slider = ref)}
					afterChange={this.afterChange}
					dots={false}
        >
          {slider.map((slide, ind) => (
            <Slide slide={slide} key={ind} index={ind}/>
          ))}
        </Carousel>
        <div className="slider-controls">
          <VideoSliderControls
            handleChangePrevSlide={this.onHandlePrevSlide}
            activeSlide={1}
            handleChangeNextSlide={this.onHandleNextSlide}
            totalSlides={10}
            showDots={width < resolutions.small_desktop ? false : true}
          >
            <Dots
              totalComponents={slider.length - 1}
              activeComponent={activeComponent}
              chooseSelectedSlide={this.chooseSelectedSlide}
            />
          </VideoSliderControls>
        </div>
      </Fragment>
    )
  }
}

export default Slider
